import {
  __,
  el,
  TextControl,
} from '../../common/variables';
import { cl } from '../../common/functions';

const editSearchLanguage = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el(TextControl,
    {
      label: __('Langue des résultats de recherche'),
      className: "input-box",
      value: attributes.searchLanguage,
      onChange: (value) => {
        setAttributes({ searchLanguage: value });
      },
      onFocus: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.querySelector('label');
        if (label) {
          label.classList.add('input-focused');
        }
      },
      onBlur: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.querySelector('label');
        if (label) {
          label.classList.remove('input-focused');
        }
      }
    }
  )
}

export { editSearchLanguage }
